import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Nav, Row, Tab } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import CurrentPrescription from 'components/prescription/CurrentPrescription';
import MedicalRecordTablePrescription from 'components/patient/medicalrecord/MedicalRecordTablePrescription';
import FileManager from 'components/utilities/FileManager';
import PatientDemographics from './PatientDemographics';
import GenerateReport from 'components/reports/GenerateReport';
import AddEditPatient from '../add-patient/AddEditPatient';
import * as accessControlObj from '../../authentication/accessControlMap'
import PatientHistory from '../patient-history/PatientHistory';

const keyOf = s => s.toLowerCase().replaceAll(' ', '-');

const NavItem = ({ item, classNameCustom }) => {
    return (
        console.log(classNameCustom),
        <Nav.Item as="li" className={`${classNameCustom}`}>
            <Nav.Link
                className={`mb-0 py-3 px-1 cursor-pointer`}
                eventKey={item.toLowerCase().replaceAll(" ", "-")}>
                {item}
            </Nav.Link>
        </Nav.Item>
    );
};

const PatientInfo = (props) => {
    const [navItems, setNavItems] = useState([]);
    const [activeKey, setActiveKey] = useState('prescription');
    const [tabPayload, setTabPayload] = useState({});           // last payload
    const tabDataRef = React.useRef({});
    const getTabPayload = (key) => tabDataRef.current[key] || {};
    const getLatestPayload = () => tabPayload || {};

    useEffect(() => {
        var localStorageAccessControl = localStorage.getItem("accessControl");
        var patientTabs = ['Prescription', 'Patient Profile'];
        // 'Medical Record', 'Prescription History', 'Patient Profile', 'File Manager', 'Reports'
        if (localStorageAccessControl.includes(accessControlObj.ACCESS_CONTROL["mym"])) {
            patientTabs.push('Medical Record');
            patientTabs.push('History');
            patientTabs.push('File Manager');
            // patientTabs.push('');
        }
        if (localStorage.getItem("roleId") > 3) {
            patientTabs.push('Reports');
        }
        setNavItems(patientTabs);
        if (!patientTabs.map(keyOf).includes(activeKey)) setActiveKey(keyOf(patientTabs[0]));
    }, []);

    const goToTab = (labelOrKey, payload = undefined) => {
        const candidate = navItems.map(keyOf).includes(labelOrKey)
            ? labelOrKey
            : keyOf(labelOrKey);
        if (!navItems.map(keyOf).includes(candidate)) return;

        if (payload !== undefined) {
            setTabPayload(payload);                // latest payload (one-shot)
            tabDataRef.current[candidate] = payload; // optional: persist per tab
        }
        setActiveKey(candidate);
    };


    return (
        <Card className="mt-5">
            <Tab.Container id="audience-tab" defaultActiveKey="prescription" activeKey={activeKey} onSelect={k => setActiveKey(k)}>
                <Card.Header
                    as={Flex}
                    justifyContent="between"
                    alignItems="center"
                    className="p-0 border-bottom patientInfoTabs"
                >
                    <Nav
                        as="ul"
                        className="nav-tabs border-0 d-flex w-100 flex-nowrap chart-tab tab-active-caret p-0"
                    >
                        {/* {navItems.map(item => (
                            <NavItem classNameCustom="col text-center" item={item} key={item} />
                        ))} */}

                        {navItems.map(item => (
                            <Nav.Item as="li" className="col text-center" key={item}>
                                <Nav.Link className="mb-0 py-3 px-1 cursor-pointer" eventKey={keyOf(item)}>
                                    {item}
                                </Nav.Link>
                            </Nav.Item>
                        ))}
                    </Nav>
                </Card.Header>

                <Card.Body>
                    <Row className="g-1">
                        <Col xxl={12}>
                            <Tab.Content>
                                <Tab.Pane unmountOnExit eventKey="prescription">
                                    <CurrentPrescription patientid={props.patient_id} facilityid={props.facilityid} data={props.paramsObj}
                                        incomingPayload={getTabPayload('prescription')}
                                        latestPayload={getLatestPayload()}
                                    />
                                </Tab.Pane>
                                {navItems.includes('Medical Record') && <Tab.Pane unmountOnExit eventKey="medical-record">
                                    <MedicalRecordTablePrescription patientid={props.patient_id} facilityid={props.facilityid} />
                                </Tab.Pane>}
                                <Tab.Pane unmountOnExit eventKey="history">
                                    <PatientHistory />
                                </Tab.Pane>
                                <Tab.Pane unmountOnExit eventKey="patient-profile">
                                    <AddEditPatient patientid={props.patient_id} facilityid={props.facilityid} data={props.paramsObj} />
                                </Tab.Pane>
                                <Tab.Pane unmountOnExit eventKey="file-manager">
                                    <FileManager />
                                </Tab.Pane>
                                <Tab.Pane unmountOnExit eventKey="reports">
                                    <GenerateReport goToTab={goToTab} data={props.paramsObj} />
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Card.Body>
            </Tab.Container>
        </Card>
    );
};

NavItem.propTypes = {
    item: PropTypes.string.isRequired
};

export default PatientInfo;